"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTPSLCloseSetting = void 0;
const react_1 = require("react");
const trade_utils_lib_1 = require("trade_utils_lib");
const types_1 = require("./types");
const TPSLStore_1 = require("./TPSLStore");
const TPSLUtils_1 = require("./TPSLUtils");
const common_business_1 = require("@pionex-web-kit/common-business");
function validateCloseQty(state) {
    const { closeMode, closeQty, tradeQty } = state;
    if (closeMode === types_1.TPSLCloseMode.CloseAmount) {
        const closeQtyD = new trade_utils_lib_1.SafeDecimal(closeQty);
        if (closeQtyD.lte(0)) {
            return { code: TPSLUtils_1.TPSLErrorCode.INVALID_CLOSE_AMOUNT, field: TPSLUtils_1.ErrorFiledName.CloseQtyField };
        }
        if (closeQtyD.gt(new trade_utils_lib_1.SafeDecimal(tradeQty))) {
            return { code: TPSLUtils_1.TPSLErrorCode.INVALID_CLOSE_AMOUNT_GT_MAX, data: { amount: tradeQty }, field: TPSLUtils_1.ErrorFiledName.CloseQtyField };
        }
    }
    return undefined;
}
/**设置止盈止损按数量平仓的hooks */
function useTPSLCloseSetting(props) {
    const { closeMode: outMode, tradeQty, scenes, closeQty: _closeQty, onChangeCloseQty, trigger_limit_price, onValidateLimitPrice, latestPrice, triggerPrice, } = props;
    /**设置平仓的量 */
    const [closeQty, setCloseQty] = (0, react_1.useState)(_closeQty);
    /**设置当前的平仓模式 */
    const [closeMode, setCloseMode] = (0, react_1.useState)(outMode);
    /**设置止盈止损的限价 */
    const [triggerLimitPrice, setTriggerLimitPrice] = (0, react_1.useState)(trigger_limit_price || "");
    /** 是否勾选止盈止损 */
    const [checkLimit, setCheckLimit] = (0, react_1.useState)(!!trigger_limit_price);
    const onChangeCloseQtyFn = (0, react_1.useRef)(onChangeCloseQty);
    onChangeCloseQtyFn.current = onChangeCloseQty;
    const onValidateLimitPriceFn = (0, react_1.useRef)(onValidateLimitPrice);
    onValidateLimitPriceFn.current = onValidateLimitPrice;
    const changeCloseMode = (0, react_1.useCallback)((mode) => {
        setCloseMode(mode);
        setCloseQty(undefined);
        if (mode === types_1.TPSLCloseMode.CloseAll) {
            setTimeout(() => {
                var _a;
                (_a = onChangeCloseQtyFn.current) === null || _a === void 0 ? void 0 : _a.call(onChangeCloseQtyFn);
            }, 0);
        }
    }, []);
    const validateCloseSetting = (0, common_business_1.usePersistFn)((estLiqPrice) => {
        function validateLimitPrice() {
            if (checkLimit) {
                if (!triggerLimitPrice || new trade_utils_lib_1.SafeDecimal(triggerLimitPrice).lte(0)) {
                    // 如果触发价格为空，表示不设置或者删除止盈止损
                    if (!triggerPrice || new trade_utils_lib_1.SafeDecimal(triggerPrice).lte(0)) {
                        return undefined;
                    }
                    return { code: TPSLUtils_1.TPSLErrorCode.INVALID_TRIGGER_LIMIT_PRICE, field: TPSLUtils_1.ErrorFiledName.OrderPriceField };
                }
                if (onValidateLimitPriceFn.current) {
                    // 校验限价是否合法
                    const err = onValidateLimitPriceFn.current(triggerLimitPrice, estLiqPrice);
                    if (err) {
                        return Object.assign(Object.assign({}, err), { field: TPSLUtils_1.ErrorFiledName.OrderPriceField });
                    }
                }
            }
            return undefined;
        }
        if (scenes !== TPSLStore_1.TPSLScene.Position) {
            return validateLimitPrice();
        }
        // 优先校验平仓数量
        return validateCloseQty({ closeMode, closeQty, tradeQty }) || validateLimitPrice();
    });
    // 当最新价格发生变化之后，需要重新进行校验
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const closeSettingWarning = (0, react_1.useMemo)(() => validateCloseSetting(), [validateCloseSetting, latestPrice]);
    const calcPnlQty = closeMode === types_1.TPSLCloseMode.CloseAll ? "" : closeQty !== null && closeQty !== void 0 ? closeQty : "";
    const checkUserModified = (0, react_1.useCallback)(() => outMode !== closeMode ||
        !new trade_utils_lib_1.SafeDecimal(_closeQty).eq(new trade_utils_lib_1.SafeDecimal(closeQty)) ||
        // 检测价格是否发生变更
        !new trade_utils_lib_1.SafeDecimal(trigger_limit_price).eq(new trade_utils_lib_1.SafeDecimal(triggerLimitPrice)) ||
        checkLimit !== !!trigger_limit_price, [_closeQty, checkLimit, closeMode, closeQty, outMode, triggerLimitPrice, trigger_limit_price]);
    const changeCloseQty = (0, react_1.useCallback)((qty) => {
        setCloseQty(qty);
        // next rendering
        setTimeout(() => {
            var _a;
            (_a = onChangeCloseQtyFn.current) === null || _a === void 0 ? void 0 : _a.call(onChangeCloseQtyFn);
        }, 0);
    }, []);
    const resetCloseSetting = (0, react_1.useCallback)(() => {
        setCloseMode(outMode);
        setCloseQty("");
        setTriggerLimitPrice("");
    }, [outMode]);
    const toggleCheckLimit = (0, react_1.useCallback)((v) => {
        setCheckLimit(v);
        setTriggerLimitPrice("");
        // 当勾选限价单时，只支持平部分
        if (v) {
            setCloseMode(types_1.TPSLCloseMode.CloseAmount);
            // 默认拉满
            setCloseQty(tradeQty);
        }
        else {
            setCloseMode(types_1.TPSLCloseMode.CloseAll);
            setCloseQty("");
        }
    }, [tradeQty]);
    const changeTriggerLimitPrice = (0, react_1.useCallback)((price, toggleCheck = false) => {
        if (toggleCheck) {
            setCheckLimit(!!price);
        }
        setTriggerLimitPrice(price);
    }, []);
    return {
        closeQty,
        setCloseQty: changeCloseQty,
        closeMode,
        setCloseMode: changeCloseMode,
        validateCloseSetting,
        closeSettingWarning,
        calcPnlQty,
        checkUserModifiedCloseSetting: checkUserModified,
        resetCloseSetting,
        tradeQty,
        triggerLimitPrice,
        changeTriggerLimitPrice,
        checkLimit,
        toggleCheckLimit,
    };
}
exports.useTPSLCloseSetting = useTPSLCloseSetting;
